import { Button } from "@resource/atlas";
import { ModalName, useModals } from "components/ModalProvider";
import UseGuideTemplateModal from "components/UseGuideTemplate/UseGuideTemplateModal";
import { JobRoleGuideTemplateSetupStatus } from "generated/schemaTypes";

export default function GuideTemplateAssignmentAction({
  selectedIds,
  isZeus,
}: {
  selectedIds: string[];
  isZeus: boolean;
}) {
  const modalManager = useModals();
  return (
    <>
      <Button
        size="small"
        onClick={() => modalManager.open(ModalName.GUIDE_TEMPLATE_SELECTOR)}
      >
        Use a template
      </Button>
      <UseGuideTemplateModal
        jobRoleGuideTemplateIds={selectedIds}
        jobSetupStatus={JobRoleGuideTemplateSetupStatus.SETUP_COMPLETE}
        isZeusJob={isZeus}
      />
    </>
  );
}
